import _ from "clsx";
import m, { forwardRef as c } from "react";
const y = "_button_w29u1_1", d = "_small_w29u1_19", p = "_inline_w29u1_25", f = "_fullWidth_w29u1_29", w = "_primary_w29u1_34", b = "_secondary_w29u1_64", h = "_tertiary_w29u1_91", t = {
  button: y,
  small: d,
  inline: p,
  fullWidth: f,
  primary: w,
  secondary: b,
  tertiary: h
}, B = "button", E = c(
  ({
    as: l,
    className: e,
    children: r,
    variant: s = "primary",
    size: a = "normal",
    fullWidth: n,
    ...i
  }, u) => {
    const o = l ?? B;
    return /* @__PURE__ */ m.createElement(o, {
      type: o === "button" ? "button" : void 0,
      ...i,
      className: _(
        t.button,
        t[s],
        {
          [t.small]: a === "small",
          [t.inline]: !n,
          [t.fullWidth]: n
        },
        e
      ),
      ref: u
    }, r);
  }
);
E.displayName = "Button";
export {
  E as Button
};
